module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "specials-link",
    style: ({
      'color': _vm.stylesObj.color
    }),
    attrs: {
      "href": "specials"
    }
  }, [_c('div', {
    staticClass: "overlay",
    style: (_vm.gradientStr)
  }), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', [_c('p', {
    staticClass: "title"
  }, [_vm._v("See our specials!")]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v("Affordable price for selected vehicles")])]), _vm._v(" "), _c('span', {
    staticClass: "label"
  }, [_vm._v("Buy now!")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-6bd97fe5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6bd97fe5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/components/inventory/specials-link.vue
// module id = 845
// module chunks = 0